<template>
	<p-dialog v-model:visible="show_modal" modal :closable="false" :close-on-esc="false" style="max-width: 400px">
		<template #header>
			<div class="flex align-items-center gap-2">
				<icon type="alert-circle-outline" size="24px" />
				<strong>Set Your Password</strong>
			</div>
		</template>
		<p>Please set a secure and memorable password for your account to continue...</p>
		<div class="password-form">
			<div class="control-group">
				<div class="inner">
					<div class="controls">
						<div class="field">
							<div class="p-inputgroup">
								<div class="p-inputgroup-addon">
									<icon type="lock" size="20px" />
								</div>
								<p-password v-model="password" placeholder="Password" />
							</div>
							<div v-if="v$.password.$error" class="validation-error">
								{{ v$.password.$errors[0].$message }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="control-group">
				<div class="inner">
					<div class="controls">
						<div class="field">
							<div class="p-inputgroup">
								<div class="p-inputgroup-addon">
									<icon type="lock-check" size="20px" />
								</div>
								<p-password v-model="confirm" placeholder="Confirm Password" :feedback="false" />
							</div>
							<div v-if="v$.confirm.$error" class="validation-error">
								{{ v$.confirm.$errors[0].$message }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<template #footer>
			<p-button icon="pi pi-check" label="Save Password" @click.enter="savePassword()" />
		</template>
	</p-dialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { setInitialUserPassword } from '@GQL';

export default {
	name: 'SetPasswordModal',
	setup() {
		return {
			v$: useVuelidate(),
		};
	},
	data() {
		return {
			show_modal: false,
			password: null,
			confirm: null,
		};
	},
	validations() {
		return {
			password: {
				required: helpers.withMessage('Please enter a secure password', required),
				secure: helpers.withMessage('Your password is not secure enough', (v) => {
					const strong_pw_pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
					return strong_pw_pattern.test(v);
				}),
			},
			confirm: {
				matches: helpers.withMessage('The passwords do not match', (v) => {
					return v === this.password;
				}),
			},
		};
	},
	methods: {
		open() {
			this.show_modal = true;
		},
		async savePassword() {
			const is_valid = await this.v$.$validate();

			if (is_valid) {
				try {
					await setInitialUserPassword(this.$root.sessionStore.user.id, this.password);

					this.$toast.add({
						severity: 'success',
						summary: 'Your password was sucessfully updated!',
						life: 5000,
					});
					this.show_modal = false;
				} catch (err) {
					console.log(err);
				}
			}
		},
	},
};
</script>

<style lang="less"></style>
